import React from 'react';

const SCORE_THRESHOLD = 0.8;

export const renderUsefulLines = (predictorData, textLetter) => {
    if (
        !predictorData || 
        !predictorData.details ||
        !predictorData.details.lines ||
        !predictorData.details.lines.length
    ) {
        return <span>{textLetter}</span>;
    }

    const linesMap = new Map(predictorData.details.lines.map(item => [item.line.toLowerCase(), item]));

    const lines = textLetter.split('\n');

    return lines.map((line, idx) => {
        const matchedData = linesMap.get(line.trim().toLowerCase());
        
        let backgroundColor = 'transparent';
        let borderLeftColor = 'transparent';

        if (matchedData) {
            const isHighScore = matchedData.predicted_score >= SCORE_THRESHOLD;
            backgroundColor = isHighScore 
                ? 'rgba(76, 175, 80, 0.25)'
                : 'rgba(244, 67, 54, 0.15)';
            borderLeftColor = isHighScore 
                ? '#4CAF50' 
                : '#F44336';
        }

        return (
            <div
                key={idx}
                style={{
                    backgroundColor,
                    borderLeft: `3px solid ${borderLeftColor}`,
                    paddingLeft: '8px',
                    margin: '2px 0',
                }}
                title={matchedData 
                    ? `Score: ${(matchedData.predicted_score * 100).toFixed(1)}% | Label: ${matchedData.predicted_label}` 
                    : ''
                }
            >
                {line || '\u00A0'}
            </div>
        );
    });
};



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Content/utils.jsx